import { useEffect, useState } from 'react'

/**
 * Whether a CSS media query currently matches.
 *
 * For the cases a class cannot express — a layout that must *not render* one
 * of its halves rather than hide it, so the hidden half costs no queries and
 * no measurement. Where hiding is enough, a `hidden md:flex` is cheaper and
 * needs no state.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window === 'undefined' ? false : window.matchMedia(query).matches,
  )

  useEffect(() => {
    const list = window.matchMedia(query)
    const onChange = () => setMatches(list.matches)
    onChange()
    list.addEventListener('change', onChange)
    return () => list.removeEventListener('change', onChange)
  }, [query])

  return matches
}

/** Tailwind's `md`. The width at which the Internal panes sit side by side. */
export const MD_QUERY = '(min-width: 768px)'

/** Under Tailwind's `lg`: where the configurator and the public pages stack
 *  instead of sitting side by side. */
export const BELOW_LG_QUERY = '(max-width: 1023px)'

/** A phone or a tablet: a finger is the pointer and nothing hovers. Where a
 *  control hands over to the operating system's own picker. */
export const TOUCH_QUERY = '(pointer: coarse) and (hover: none)'

/** What the operating system asks for, where a component has to name the
 *  theme it is offering rather than only wear it. */
export const DARK_SCHEME_QUERY = '(prefers-color-scheme: dark)'
